module.exports = __webpack_public_path__ + "static/media/shane_new.61a8a21c.jpeg";